export default __webpack_public_path__ + "media/support.3ed93dc5.svg";